import overlay from './loader';
import eventBus from './event-bus';

$(document)
    .on('change', '[role="select-modal-action"] select', function (e) {
        let modalEle = $('#' + $.trim(e.target.value));

        modalEle.modal('show');
        e.stopPropagation();

        // Reset the select to placeholder option after modal closed
        modalEle.on('hide.bs.modal', () => e.target.value = '');
    });

export const initCartCustomerReference = function () {
    $('#customer_reference').on('keyup', null, _.debounce((event) => {
        let referenceInput       = event.target,
            validationMessageEle = referenceInput.parentNode.querySelector('.invalid-feedback'),
            formEle              = referenceInput.form;

        formEle.querySelector(`.workflow-transition.workflow-${referenceInput.dataset.workflow}`).value = referenceInput.dataset.transition;
        overlay(true);
        window.axios.post(formEle.action, new FormData(formEle))
            .then(() => {
                formEle.classList.remove('was-validated');

                // Remove the pseudo :invalid fo the input field and the error message
                referenceInput.setCustomValidity('');
                validationMessageEle.innerHTML = '';
            })
            .catch(error => {
                formEle.classList.add('was-validated');

                // Add the pseudo :invalid fo the input field and show the error message
                referenceInput.setCustomValidity(error.message);
                validationMessageEle.innerHTML = 'The error message';

                // @todo Error handler for 200 error response
            })
            .finally(() => overlay(false));
    }, 700));
};

window.addEventListener("DOMContentLoaded", () => initCartCustomerReference);
eventBus.on('cart-item-quantity-change', initCartCustomerReference);
